import script from "./AdminFormElementTableref.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementTableref.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementTableref.vue?vue&type=style&index=0&id=72f95098&lang=scss"

const __exports__ = script;

export default __exports__